import api from '../../../services/Api';
import { IAuditoriaProvisaoPisCofinsResultado } from '../interfaces/IAuditoriaProvisaoPisCofins';

export const AuditoriaProvisaoPisCofinsService = {
  async buscarResultado(params: {
    empresaId: number;
    periodo?: string;
  }): Promise<IAuditoriaProvisaoPisCofinsResultado> {
    const response = await api.get<IAuditoriaProvisaoPisCofinsResultado>('auditoria-provisao-pis-cofins/resultado', {
      params: {
        empresaIds: params.empresaId,
        periodo: params.periodo || '',
      },
    });

    return (
      response.data || {
        impactoFiscalTotal: 0,
        impactoFinanceiroTotal: 0,
        totalAvisos: 0,
        totalAlertas: 0,
        totalErros: 0,
        status: 'CONCILIADO',
        mensagemDirecionamento: '',
        fundamentacaoFiscal: '',
        fundamentacaoContabil: '',
        provisoesAusentes: [],
        mesesConciliados: [],
      }
    );
  },
};
